import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import { HashLink } from "react-router-hash-link";
import { useAuth } from "../../context/AuthContext";
import Fade from "react-reveal/Fade";

import HelpDrawer from "./HelpDrawer";
import HelpDrawerText from "./HelpDrawerText";

import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";
import CurrencyFormat from "react-currency-format";

import {
  db,
  collection,
  query,
  where,
  getDocs,
  doc,
  getDoc,
} from "../../firebase";

import { useParams } from "react-router-dom";

const useStyles = makeStyles({
  body: {
    backgroundColor: "white",
    minHeight: "500px",
    padding: "50px",
  },
  title: {
    fontSize: "22px",
  },
});

const Dashboard = () => {
  const { t, i18n } = useTranslation();
  let { id } = useParams();
  const { currentUser } = useAuth();
  const classes = useStyles();
  const [order, setOrder] = useState([]);
  const [pass, setPass] = useState(null);
  const [msg, setMsg] = useState(null);
  const [orderId, setOrderId] = useState(id || null);
  const [country, setCountry] = useState("KO");

  console.log("orderId", orderId);

  useEffect(() => {
    getOrder();
  }, []);

  const getOrder = async () => {
    console.log("getOrder is called");
    console.log("orderId", orderId);

    if (orderId) {
      let docRef = doc(db, "KO_orders", orderId.trim());
      let docSnap = await getDoc(docRef);

      console.log("docSnap", docSnap.data());

      if (docSnap.exists()) {
        console.log("Document data:", docSnap.data());
        if (docSnap.data().guestPassword === pass.trim()) {
          setOrder(docSnap.data());
          setMsg("");
          setCountry("KO");
        } else {
          setOrder(null);
          setMsg(
            t(
              "We found your order but password is not matched. Please check your pass code."
            )
          );
        }
      } else {
        setMsg("We could not find the order.");
      }
      let docRef2 = doc(db, "US_orders", orderId.trim());
      let docSnap2 = await getDoc(docRef2);

      console.log("docSnap2", docSnap2.data());

      if (docSnap2.exists()) {
        console.log("Document data:", docSnap2.data());
        if (docSnap2.data().guestPassword === pass.trim()) {
          setOrder(docSnap2.data());
          setMsg("");
          setCountry("US");
        } else {
          setOrder(null);
          setMsg(
            t(
              "We found your order but password is not matched. Please check your pass code."
            )
          );
        }
      } else {
        setMsg("We could not find the order.");
      }
    }
  };

  console.log(order);

  return (
    <Grid
      container
      sx={{
        px: { md: 10, sm: 5 },
        pt: 7,
        pb: 20,
        backgroundColor: "#eceff1",
      }}
    >
      <Grid item sm={12} md={12} sx={{ fontSize: "19px", pb: 2, pl: 2 }}>
        <Box>{t("GUEST CHECK OUT")}</Box>
      </Grid>

      {/* <LeftMenu cursor="dashboard" /> */}
      <Grid item md={12} sm={12} className={classes.body}>
        <Box
          sx={{
            width: 1,
            display: "flex",
            justifyContent: "space-between",
            // border: "1px solid black",
          }}
        >
          <Box className={classes.title}>
            <Fade delay={300}>{t("Your Order")}</Fade>
          </Box>
          <Box
            sx={{
              position: "relative",
              top: "-10px",
              border: "1px solid lightgray",
              borderRadius: "20px",
            }}
          >
            <HelpDrawer />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",

            mt: 2,
            mb: 1,
          }}
        >
          <Box sx={{ mb: 2, lineHeight: "1.8em" }}>
            <div
              dangerouslySetInnerHTML={{
                __html: t(
                  "Search with Order ID you put when you checkout. It is also in your checkout confirmation email."
                ),
              }}
            />
            <Box sx={{ color: "gray" }}>
              <HashLink smooth to="/faq#top">
                [{t("Contact Us Page")}]
              </HashLink>
            </Box>
          </Box>
          <Box>
            <TextField
              id="filled-basic"
              label={t("Search with Order ID ")}
              variant="filled"
              sx={{ width: { md: 1 / 4, sm: 1 } }}
              onChange={(e) => setOrderId(e.target.value)}
            />
            <TextField
              id="filled-basic"
              label={t("pass")}
              variant="filled"
              onChange={(e) => setPass(e.target.value)}
              sx={{ width: { md: 1 / 4, sm: 1 }, ml: 2 }}
            />
            <button
              className="custom_btn"
              style={{ width: "100px" }}
              onClick={getOrder}
            >
              {t("Search")}
            </button>
          </Box>
        </Box>{" "}
        <Box>
          {msg ? (
            <Box sx={{ mt: 3, color: "#153a5a" }}>{msg}</Box>
          ) : order?.created ? (
            <Box sx={{ mt: 3, color: "#153a5a" }}>
              {t("Here is your order.")}
            </Box>
          ) : (
            <Box sx={{ mt: 3, color: "#153a5a" }}>
              {t("Please search an order.")}
            </Box>
          )}
        </Box>
        {order?.created && (
          <Box sx={{ pt: 2, px: 25, fontSize: "14px" }}>
            {/* order partial */}
            <Box className="textBox" style={{ marginBottom: "20px" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  borderBottom: "1px solid #e0e0e0",
                  paddingBottom: "10px",
                  marginTop: "10px",
                  fontSize: "13px",
                }}
              >
                <Box sx={{ fontSize: "13px" }}>
                  {t("Order Placed")} :{" "}
                  {order?.created?.toDate().toLocaleDateString("fr-CA", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                  })}{" "}
                  {order?.created?.toDate().toLocaleTimeString("ko-KR")}
                </Box>
                <Box sx={{ fontSize: "13px", display: "flex" }}>
                  <Box
                    className=""
                    sx={{
                      ml: 2,
                      color: "#153a5a",
                      display: "flex",
                      fontSize: "12px",
                    }}
                  >
                    <HashLink to={"/contact/" + orderId + "#top"}>
                      {t("Contact Us About This Order")}
                    </HashLink>

                    {/* <Box sx={{ ml: 2 }}>Print Receipt</Box> */}
                  </Box>
                </Box>
              </Box>
              {/* <Box sx={{ pt: 2 }}>
                <span className="gray">{t("Order")} #:</span> {order.id}
              </Box> */}
              <Box sx={{ color: "black", pt: 2, fontSize: "13px" }}>
                <span className="gray">{t("Status")}:</span>{" "}
                <span className="pink_link">
                  {t(order.status[order.status.length - 1])}
                </span>
              </Box>
              <Box sx={{ pb: 1, pt: 1, fontSize: "13px" }}>
                {t("ORDER DETAILS")}
              </Box>
              {order.address_address && (
                <Box sx={{ fontSize: "13px" }}>
                  <span className="gray" style={{ fontSize: "13px" }}>
                    {t("Ship to")}:
                  </span>{" "}
                  &nbsp;
                  {order.address_lastname}&nbsp;{order.address_firstname}&nbsp;
                  {order.address_address}
                  &nbsp;
                  {order.address_apt}&nbsp;{order.address_city}&nbsp;
                  {order.address_state}&nbsp;{order.address_zipcode}
                </Box>
              )}
              <Box
                sx={{
                  fontSize: "13px",
                  pt: 2,
                  color: "#757575",
                  display: "flex",
                  justifyContent: "space-between",
                  flex: 1,
                }}
              >
                <Box>
                  {order.basket &&
                    JSON.parse(order?.basket).map((item, idx) => {
                      // console.log(item);
                      let link =
                        "/dashboard-leave-a-new-review?productId=" +
                        item.id +
                        "&name=" +
                        item.name +
                        "&link" +
                        item.linkTo +
                        "&id=" +
                        currentUser?.uid;
                      // console.log(link);
                      return (
                        <Box key={idx} sx={{ color: "black" }}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              fontSize: "15px",
                              pl: 4,
                              pt: 2,
                            }}
                          >
                            <img src={item.image} alt="" width="60" />
                            <Box sx={{ pl: 2, fontSize: "12px" }}>
                              {item.quantity}x {t(item.name)}&nbsp;
                            </Box>
                          </Box>
                        </Box>
                      );
                    })}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    minWidth: "200px",
                  }}
                >
                  <Box sx={{ fontSize: "22px", color: "black", pb: 2 }}>
                    {country === "KO" ? (
                      <CurrencyFormat
                        decimalScale={2}
                        value={order.finalPrice}
                        displayType={"text"}
                        thousandSeparator={true}
                        suffix={"원"}
                      />
                    ) : (
                      <CurrencyFormat
                        decimalScale={2}
                        value={order.finalPrice}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"$"}
                      />
                    )}
                  </Box>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Box>{t("Subtotal")}</Box>
                    <Box>
                      {country === "KO" ? (
                        <CurrencyFormat
                          decimalScale={2}
                          value={order.subtotal}
                          displayType={"text"}
                          thousandSeparator={true}
                          suffix={"원"}
                        />
                      ) : (
                        <CurrencyFormat
                          decimalScale={2}
                          value={order.subtotal}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                        />
                      )}
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      pb: 1,
                    }}
                  >
                    <Box>{t("Shipping")}</Box>
                    <Box>
                      {country === "KO" ? (
                        <CurrencyFormat
                          decimalScale={2}
                          value={order.shippingPrice}
                          displayType={"text"}
                          thousandSeparator={true}
                          suffix={"원"}
                        />
                      ) : (
                        <CurrencyFormat
                          decimalScale={2}
                          value={order.shippingPrice}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                        />
                      )}
                    </Box>
                  </Box>

                  <Box sx={{ borderTop: "1px solid lightgray", pt: 1 }}></Box>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Box>{t("Total")}</Box>
                    <Box>
                      {country === "KO" ? (
                        <CurrencyFormat
                          decimalScale={2}
                          value={order.finalPrice}
                          displayType={"text"}
                          thousandSeparator={true}
                          suffix={"원"}
                        />
                      ) : (
                        <CurrencyFormat
                          decimalScale={2}
                          value={order.finalPrice}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                        />
                      )}
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    pl: 2,
                    pt: 2,
                    color: "#153a5a",
                    textDecoration: "underline",
                  }}
                >
                  <HelpDrawerText />
                </Box>
              </Box>
            </Box>
            {/* order partial */}
          </Box>
        )}
      </Grid>
    </Grid>
  );
};

export default Dashboard;
